"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const scroll_styles_1 = require("@/components/common/scroll/scroll.styles");
require("@/components/common/scroll/semantics/scroll-hint");
/**
 * 내용이 넘칠 때 스크롤되는 컨테이너.
 * flex·grid와 달리 내부 래퍼 없이 host 자체가 스크롤 컨테이너이므로,
 * scrollLeft·scrollTop 등 스크롤 API를 host에서 바로 사용할 수 있다.
 * 가로 스크롤(row)은 양 끝에 mm-scroll-hint를 두어, 가려진 쪽을 흐림과 넘김 버튼으로 알린다.
 */
let Scroll = class Scroll extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.direction = 'row';
        this.hideScrollbar = false;
    }
    render() {
        if (this.direction === 'column') {
            return (0, lit_1.html) `
        <slot></slot>
      `;
        }
        return (0, lit_1.html) `
      <mm-scroll-hint placement="start"></mm-scroll-hint>
      <slot></slot>
      <mm-scroll-hint placement="end"></mm-scroll-hint>
    `;
    }
};
Scroll.styles = scroll_styles_1.scrollStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Scroll.prototype, "direction", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Scroll.prototype, "gap", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true, attribute: 'hide-scrollbar' })
], Scroll.prototype, "hideScrollbar", void 0);
Scroll = __decorate([
    (0, decorators_js_1.customElement)('mm-scroll')
], Scroll);
exports.Scroll = Scroll;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Nyb2xsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2Nyb2xsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBMkQ7QUFJM0QsNEVBQXVFO0FBQ3ZFLDREQUF5RDtBQUV6RDs7Ozs7R0FLRztBQUVJLElBQU0sTUFBTSxHQUFaLE1BQU0sTUFBTyxTQUFRLGdCQUFVO0lBQS9COztRQUVzQyxjQUFTLEdBQWtCLEtBQUssQ0FBQTtRQUVGLGtCQUFhLEdBQUcsS0FBSyxDQUFBO0lBZWhHLENBQUM7SUFiQyxNQUFNO1FBQ0osSUFBSSxJQUFJLENBQUMsU0FBUyxLQUFLLFFBQVEsRUFBRTtZQUMvQixPQUFPLElBQUEsVUFBSSxFQUFBOztPQUVWLENBQUE7U0FDRjtRQUVELE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozs7S0FJVixDQUFBO0lBQ0gsQ0FBQzs7QUFqQk0sYUFBTSxHQUFHLDRCQUFZLENBQUE7QUFDZTtJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzt5Q0FBaUM7QUFDaEM7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7bUNBQVk7QUFDbUI7SUFBeEUsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxnQkFBZ0IsRUFBRSxDQUFDOzZDQUFzQjtBQUpuRixNQUFNO0lBRGxCLElBQUEsNkJBQWEsRUFBQyxXQUFXLENBQUM7R0FDZCxNQUFNLENBbUJsQjtBQW5CWSx3QkFBTSJ9